
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    DEVICES_BULK_PAIRING_REQUEST,
    DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST,
    DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    bulkPairingResult,
    bulkPairingSearchDevicesResult,
    bulkPairingSearchIdResult,
} from 'Redux/actions';

function* bulkPairing({ payload }) {
    try {
        const QUERY = `
            mutation bulkPairingBatch ($pairing: [BulkPairingInput]) {
                result: bulkPairingBatch (pairing: $pairing) {
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                pairing: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(bulkPairingResult(data?.result))
        } else {
            yield put(bulkPairingResult({ error: true }))
        }

    } catch (exc) {
        yield put(bulkPairingResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkPairing/redux/saga",
            "bulkPairing",
        )
    }
}

function* searchDevices({ payload }) {
    try {
        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        esn
                        label
                        deviceModel {
                            manufacturerId
                            manufacturer {
                                id
                                name
                                active
                            }
                        }
                        linkedMode
                        companyId
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn"],
                    terms: [
                        payload?.cameraEsn,
                        payload?.gpsEsn,
                    ],
                    exact: true
                },
                limit: 2,
                offset: 0
            },

            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result;
            yield put(bulkPairingSearchDevicesResult(items))
        } else {
            yield put(bulkPairingSearchDevicesResult({ error: true }))
        }

    } catch (exc) {
        yield put(bulkPairingSearchDevicesResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkPairing/redux/saga",
            "searchDevices",
        )
    }
}

function* searchDeviceId({ payload }) {
    try {
        const { devices, type } = payload;
        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        esn
                        label
                        deviceModel {
                            manufacturerId
                            manufacturer {
                                id
                                name
                                active
                            }
                        }
                        linkedMode
                        companyId
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn"],
                    terms: [...devices],
                    exact: true
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(bulkPairingSearchIdResult(items, type))
        }

    } catch (exc) {
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkPairing/redux/saga",
            "searchDeviceId",
        )
    }
}

function* watchMethods() {
    yield takeEvery(DEVICES_BULK_PAIRING_REQUEST, bulkPairing);
    yield takeEvery(DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST, searchDevices);
    yield takeEvery(DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST, searchDeviceId);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}